export default class PersonalReportEvent {
    constructor(type) {
        this._type = type;
    }

    get type() {
        return this._type;
    }
}

PersonalReportEvent.GENERATE = 'PersonalReportEvent.GENERATE';
PersonalReportEvent.ERROR = 'PersonalReportEvent.ERROR';